import {OttopilotEventContainersWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainersWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotEventContainersWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotEventContainers> & {
    fixedUdoTemplates: {
        [OttopilotEventContainersWorkspaceCapabilityUdoTemplateKey.roundRobinCursor]: {
            udoAdditionalColumnIds: {
                assignmentKey: Uuid;
                eligibleUserCount: Uuid;
                lastAssignedUserId: Uuid;
            };
        };
    };
    /** Owned dynamic UDO templates keyed by Event Container template ID. Columns live on the UDO template. */
    eventContainerUdoTemplates: Record<
        Uuid,
        {
            udoTemplateId: Uuid;
        }
    >;
};

export const ottopilotEventContainersWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [OttopilotEventContainersWorkspaceCapabilityUdoTemplateKey.roundRobinCursor]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({assignmentKey: uuidZodValidator, eligibleUserCount: uuidZodValidator, lastAssignedUserId: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
    eventContainerUdoTemplates: zod.record(
        uuidZodValidator,
        zod.strictObject({
            udoTemplateId: uuidZodValidator,
        }),
    ),
}) satisfies zod.ZodType<OttopilotEventContainersWorkspaceCapabilityUdoBindings>;
